import { Component, OnInit, OnDestroy, Input, ViewChild, ElementRef, } from '@angular/core';
import { CreateResult } from "../../models/create-result";
import { ActivatedRoute, Router } from '@angular/router';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { ToastrService } from "ngx-toastr";
import { UserDataStoreService } from "../../services/user-data-store.service";
import { TerminalConfigViewModel } from "../../models/terminal-config-view-model";

import { TerminalConfigService } from "../../services/terminal-config.service";
import { Select2OptionData } from 'ng-select2';
import { PermissionEnum } from '../../services/guards/permissions';
import { ParticipantService } from '../../services/participant.service';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { NgbDate, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AuthenticationService } from "../../services/authentication.service";
import { ECONNRESET } from 'constants';
import { ConfirmationDialogComponent } from '../../partials/confirmation-dialog/confirmation-dialog.component';
import { DataTableDirective } from 'angular-datatables';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { CustomTagsParticipantLinkViewModel } from '../../models/custom-tags-participant-link';
import { CustomTagService } from '../../services/custom-tag.service';
import { ParticipantViewModel } from '../../models/participant-view-model';
import { TerminalGroupsByParticipantLinkViewModel } from '../../models/terminal-groups-participant-link';
import { TerminalGroupCustomParameterComponent } from './terminal-group-custom-parameter/terminal-group-custom-parameter.component';
import { TerminalGroupCustomParameter } from '../../models/terminal-group-param-view-model';
import { ESocketConfigComponent } from './e-socket-config/e-socket-config.component';

@Component({
  selector: 'app-terminal-config-view',
  templateUrl: './terminal-config-view.component.html',
  styleUrls: ['./terminal-config-view.component.scss']
})
export class TerminalConfigView implements OnInit, OnDestroy {

  @Input()
  maxNumberOfCharacters = 16; // Added by Lebohang 10feb 2021
  numberOfCharacters1 = 0; // Added by Lebohang 10feb 2021
  public terminalConfigForm: FormGroup;

  public submitted = false;

  public id: string;
  public configViewModel: TerminalConfigViewModel;
  public participants: Select2OptionData[];
  public countryCodes: Select2OptionData[];
  public baseCurrencies: Select2OptionData[]
  public terminalTypes: Select2OptionData[];
  public timezonecodes: Select2OptionData[];
  public bINProfiles: Select2OptionData[];
  public driverIds: Select2OptionData[];
  public disableMediaManagement: Select2OptionData[];
  public supportTeams: Select2OptionData[];
  public timeZones: Select2OptionData[];
  public suppliesTeams: Select2OptionData[];
  public mediaTeams: Select2OptionData[];
  public securityTeams: Select2OptionData[];
  public participantFormControl: FormControl;
  public createResult: CreateResult;
  public errorMessage = "";
  public disabled = false;
  public termApp = 1;
  public postTerm = 2;
  public eSocket = 3;

  public canAdd = false;
  public canEdit = false;
  public canView = false;
  public canDelete = false;
  public addEditButton: string;

  public EditTerminal = "";
  public DeleteButton = "";
  public terminalId: string;

  public displayTAContent = false;
  public raiseWarning: boolean;
  public warning: string;
  public raiseDanger = true;
  public danger: string;
  public eSocketConfig: boolean;
  private _destroyed$ = new Subject<any>();
  public creatingNew = false;

  @ViewChild(DataTableDirective)
  public dtElement: DataTableDirective;
  dtInstance: Promise<DataTables.Api>;
  @ViewChild('content') content: ElementRef;
  public dtOptions: DataTables.Settings;
  public dtTrigger: Subject<boolean> = new Subject();
  public editConfig: boolean;

  @ViewChild(ESocketConfigComponent) _eSocketConfigComponent: ESocketConfigComponent;

  public select2options: any = {
    multiple: false,
    width: '100%'
  };

  public get FunctionVectors(): Select2OptionData[] {
    const items = [
      { id: 'false', text: 'Disabled' },
      { id: 'true', text: 'Enabled' }
    ];
    this.ConfigTypesSelect2 = items;
    return items;
  }

  public get TerminalActivate(): Select2OptionData[] {
    const items = [
      { id: "0", text: 'False' },
      { id: "1", text: 'True' }
    ];
    this.ConfigTypesSelect2 = items;
    return items;
  }

  public get ConfigTypes(): Select2OptionData[] {
    const items = [
      { id: "1", text: 'TermApp' },
      { id: "2", text: 'PostTerm' }, 
      { id: "3", text: 'eSocket' }
    ];
    this.ConfigTypesSelect2 = items;
    return items;
  }

  public get terminalConfigTypes() {
    return [
      { id: 1, text: 'TermApp' },
      { id: 2, text: 'PostTerm' }
    ];
  }
  public get TimeZone(): Select2OptionData[] {
    const items = [
      { id: 'Africa/Johannesburg', text: 'Africa/Johannesburg' }
    ];
    this.timeZones = items;
    return items;
  }

  public ConfigTypesSelect2: Select2OptionData[] = [];

  //custom tags

  public customTagsByParticipant: CustomTagsParticipantLinkViewModel[] = [];
  public customTags: Select2OptionData[];
  public allsinkNodes: Select2OptionData[];
  public mapCustomTags: Select2OptionData[];
  public TerminalGroupsByParticipant: TerminalGroupsByParticipantLinkViewModel[] = [];
  public mapTerminalGroupTags: Select2OptionData[];
  public terminalGroups: Select2OptionData[];
  public participant: ParticipantViewModel;
  public participantId?: number;

  public selectedCustomTag: string;
  public selectedGroup: string;
  public terminalGroupCustomParameter: TerminalGroupCustomParameter;

  constructor(private _route: ActivatedRoute,
    private _terminalConfigService: TerminalConfigService,
    private _authenticationService: AuthenticationService,
    private _participantService: ParticipantService,
    private _toastService: ToastrService,
    private _userDataStore: UserDataStoreService,
    private _router: Router,
    private _formBuilder: FormBuilder,
    private _modalService: NgbModal,
    private _ngxUiLoaderService: NgxUiLoaderService,
    private _customTagService: CustomTagService) {

    this.terminalConfigForm = this._formBuilder.group({
      id: [''],
      name: ['', [Validators.required]],
      configType: ['', [Validators.required]],
      participantId: [_userDataStore.selectedParticipant.id],
      active: ['', [Validators.required]],
      baseCurrency: ['', [Validators.required]],
      countryCode: ['', [Validators.required]],
      dropIdleConnections: ['', [Validators.required, Validators.min(1)]],
      postalServiceCode: ['000000000', [Validators.required]],
      sponsorBank: ['', [Validators.required]],
      stateCode: ['', [Validators.required]],
      worstEventSeverity: ['', [Validators.required, Validators.min(1)]],
      disableMediaManagement: [1],// [Validators.required, Validators.min(1)]],
      secModNr: ['', [Validators.minLength(16)]],
      driverId: [1],// [Validators.required]],

      macMasterKey: [''],
      mediaTeam: [0],
      miscellaneous: [''],
      mode: [0],
      pinMasterKey: [''],
      securityTeam: [0],
      status: [''],
      suppliesTeam: [0],
      supportTeam: [0],
      timeZone: [''],
      valueBars: [''],
      posDataCode: ['', [Validators.required]],
      heartBeat: [0],
      heartbeatDelay: [0],
      timeZoneCode: [''],
      sampleRate: [1],//, [Validators.required]],
      binProfile: [''],
      echoInterval: [0],
      dukptManagement: [0],
      type: [0],
      countyCode: [''],
      termRktScheme: [''],
      usePosDataCodeConfig: [0],
      enableEjUpload: [0],
      hotFileId: [0],
      disableHotcards: [1],
      daysToKeepStats: [0],
      functionVector: [false],
      gmtTimeZoneOffset: [0],
      hardwareConfig: [''],
      lastMessageTime: [null],
      lastMessageType: [''],
      lastTranMsgTime: [null]

    });

    this.canView = this._userDataStore.hasRequiredPermissions([PermissionEnum.ViewTerminalConfiguration], []);
    if (!this.canView) {
      this._toastService.warning("You do not have the required permissions to view this terminal config.", "Warning");
      this._router.navigate(['Default', 'Home']);
    }

    _route.params.pipe(takeUntil(this._destroyed$)).subscribe(async params => {
      
      if (params.id != 'new') {
        this.disabled = true;
        this.editConfig = true;
        this.creatingNew = false;
        this.id = params.id;
        this.terminalId = params.id;

        const result = await this._terminalConfigService.Get(params.id);
        this.terminalConfigForm.patchValue(result);

        //check if user is eligible to edit and delete
        this.canEdit = this._userDataStore.hasRequiredPermissions([PermissionEnum.EditTerminalConfiguration], []);
        this.canAdd = this._userDataStore.hasRequiredPermissions([PermissionEnum.AddTerminalConfiguration], []);
        if (!this.canEdit && !this.canAdd) {
          //this._toastService.warning("Please note that you do not have the required permissions to update this terminal config.", "Warning");
          this.addEditButton = "display:none";
          this.warning = "Please note that you do not have the required permissions to update this terminal config";
          this.raiseWarning = false;//Frans: Changed to false

          //disable controls.
          Object.keys(this.terminalConfigForm.controls).forEach(key => {
            this.terminalConfigForm.controls[key].disable();
          });

        }

        this.canDelete = this._userDataStore.hasRequiredPermissions([PermissionEnum.DeleteTerminalConfiguration], []);
        if (!this.canDelete) {
          this.DeleteButton = "display: none";
        }

        this.updateForm();
      }
      else {
        this.initDefaultValues();
        this.updateForm();
        this.editConfig = false;
        this.creatingNew = true;
        this.DeleteButton = "display: none";

        //check if user is eligible to add
        this.canAdd = this._userDataStore.hasRequiredPermissions([PermissionEnum.AddTerminalConfiguration], []);
        if (!this.canAdd) {
          this._toastService.warning("You do not have the required permissions to Add a terminal config.", "Warning");
          this.addEditButton = "display:none";
        }
      }
      //custom parameters
      this.customTags = (await this._customTagService.GetCustomTags()).map((x) => {
        return { id: x.tag.toString(), text: x.tag }
      });

      this.initParticipant(_userDataStore.selectedParticipant.id);
      if (this.participant == null) {
        this.participantId = _userDataStore.selectedParticipant.id;
      }
      else {
        this.participantId = this.participant.id;
      }
      if (this.creatingNew == false) {
        this.customTagsByParticipant = await this._customTagService.GetCustomTagsByParticipantIdTerminalConfigId(this.participantId, Number(this.id));
      }
      this.filterCustomTags();

      //terminal groups
      this.terminalGroups = (await this._customTagService.GetTerminalGroups()).map((x) => {
        return { id: x.term_group_name.toString(), text: x.term_group_name }
      });
      if (this.creatingNew == false) {
        this.TerminalGroupsByParticipant = await this._customTagService.GetGroupsByParticipantIdTerminalConfigId(this.participantId, Number(this.id));
      }
      //mapTerminalGroupTags


    });
  }

  public initDefaultValues(): void {
    this.configViewModel = {
      participantId: this._userDataStore.selectedParticipant.id,
      name: `Terminal config - ${Math.floor(Date.now() / 1000)}`,
      configType: this.termApp,
      active: 1,
      baseCurrency: '710',
      countryCode: '710',
      disableHotcards: 1,
      dropIdleConnections: 1,
      daysToKeepStats: 10,
      functionVector: false,
      gmtTimeZoneOffset: 0,
      hardwareConfig: null,
      lastMessageTime: null,
      lastMessageType: '',
      lastTranMsgTime: null,
      macMasterKey: null,
      mediaTeam: 1,
      miscellaneous: null,
      mode: 0,
      pinMasterKey: null,
      postalServiceCode: '000000000',
      secModNr: null,
      securityTeam: 1,
      sponsorBank: 'AbsaBank',
      stateCode: '00',
      status: null,
      suppliesTeam: 1,
      supportTeam: 1,
      timeZone: 'Africa/Johannesburg',
      valueBars: null,
      worstEventSeverity: 1,
      posDataCode: 'A1010171134C101',
      heartBeat: 0,
      heartbeatDelay: 0,
      timeZoneCode: 'EET',
      sampleRate: 51,
      binProfile: '',
      echoInterval: 0,
      dukptManagement: 1,
      disableMediaManagement: 2,
      type: 22,
      countyCode: '710',
      termRktScheme: null,
      usePosDataCodeConfig: 0,
      enableEjUpload: 0,
      hotFileId: 0,
      driverId: 1
    };
    this.terminalConfigForm.patchValue(this.configViewModel);
  }

  //==============custom parameters

  public async saveTerminalGroups(): Promise<void> {

    if (!this.canEdit) {
      this._toastService.error('You do not have the required permissions to perform this action.', 'Error');
    } else {

      if (this.creatingNew == false) {
        this.createResult = await this._customTagService.DeleteTerminalGroupByParticipantIdAndTerminalConfig(this.participantId, Number(this.id));

        if (this.createResult.success) {
          this.createResult = await this._customTagService.UpdateTerminalGroup(this.TerminalGroupsByParticipant);
          if (this.createResult.success) {
            this._toastService.success(this.createResult.message, 'Success');
          } else {
            this._toastService.error(this.createResult.message, 'Error');
          }
        }
      }
      else {
        this._toastService.error(this.createResult.message, 'Error');
      }
    }
  }

  public async addTerminalGroup(): Promise<void> {

    let group: string = this.selectedGroup;
    if (group == null) {
      alert('Select a group');
    }
    else {

      if (!this.canEdit) {
        this._toastService.error('You do not have the required permissions to perform this action.', 'Error');
      } else {

        var groupObject = {
          groupName: this.selectedGroup,
          participantId: this.participantId,
          terminalConfigId: (this.id != 'new' ? Number(this.id) : 0)
        }


        this.createResult = await this._customTagService.AddTerminalGroup(groupObject);
        if (this.createResult.success) {

          this.TerminalGroupsByParticipant.push(groupObject);

          this._toastService.success(this.createResult.message, 'Success');
        } else {
          this._toastService.error(this.createResult.message, 'Error');
        }

      }
      //add to database


      this.filterTerminalGroups();

    }
  }

  public async determineGroupDeleteDialog(groupName: string) {

    const dialogRef = this._modalService.open(ConfirmationDialogComponent, {
      windowClass: 'modal-fade-in',
      centered: false,
      size: 'xl',
      backdrop: 'static'
    });
    dialogRef.componentInstance.showCancel = true;
    dialogRef.componentInstance.acceptButtonText = 'Yes';
    dialogRef.componentInstance.cancelButtonText = 'No'
    dialogRef.componentInstance.title = 'Terminal Group Removal'
    dialogRef.componentInstance.message = 'Are you sure you want to delete the selected terminal group?'

    const result = await dialogRef.result;
    if (result) {
      await this.deleteTerminalGroup(groupName);
    }
  }

  public async deleteTerminalGroup(groupName: string): Promise<void> {

    const index = this.TerminalGroupsByParticipant.findIndex(x => x.groupName == groupName);

    if (index > -1) {

      var groupObject = {
        groupName: groupName,
        participantId: this.participantId,
        terminalConfigId: (this.id != 'new' ? Number(this.id) : 0)
      }

      this.createResult = await this._customTagService.DeleteTerminalGroup(groupObject);

      if (this.createResult.success) {

        this.TerminalGroupsByParticipant.splice(index, 1);

        this._toastService.success(this.createResult.message, 'Success');
      } else {
        this._toastService.error(this.createResult.message, 'Error');
      }
    }
    this.filterTerminalGroups();
  }


  public filterCustomTags(): void {
    const filteredItems = this.customTags.filter((item) => {
      if (this.customTagsByParticipant != null) {
        const index = this.customTagsByParticipant.findIndex(x => x.customTag.toString() === item.text);
        if (index > -1) {
          return false;
        }
      }
      return true;
    });
    this.mapCustomTags = filteredItems;
  }

  public filterTerminalGroups(): void {

    const filteredItems = this.terminalGroups.filter((item) => {
      if (this.TerminalGroupsByParticipant != null) {
        const index = this.TerminalGroupsByParticipant.findIndex(x => x.groupName.toString() === item.text);
        if (index > -1) {
          return false;
        }
      }
      return true;
    });
    this.mapTerminalGroupTags = filteredItems;
  }

  public async initParticipant(id: number): Promise<void> {
    this.participant = await this._participantService.GetParticipant(id);
  }

  public async setCustomParamEditable(value, groupname: string): Promise<void> {
    var groupItem = {
      groupName: groupname,
      participantId: this.participantId,
      terminalConfigId: (this.id != 'new' ? Number(this.id) : 0),
      customParameterEditable: value.target.checked
    }


    this.createResult = await this._customTagService.setCustomParamEditable(groupItem);
    if (this.createResult.success) {
      this._toastService.success(this.createResult.message, 'Success');
    } else {
      this._toastService.error(this.createResult.message, 'Error');
    }
  }


  public async isAllCustomParam(terminalgroup: TerminalGroupsByParticipantLinkViewModel): Promise<boolean> {
    if (terminalgroup)
    {
      return terminalgroup.customParameterEditable;
    } else {
      return false;
    }
  }
  //========================

  ngOnInit() {

    this.dtOptions = {
      pageLength: 10,
      pagingType: 'full_numbers'
    };
    this.init();
  }

  public async initTable(selectedIndex: number): Promise<void> {
    await this._loadTabData(selectedIndex);
    // this.rerender();
  }

  rerender(): void {
    if ("dtInstance" in this.dtElement) {
      this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
        // Destroy the table first
        dtInstance.destroy();
        // Call the dtTrigger to rerender again
        this.dtTrigger.next();
      });
    }
    else {
      this.dtTrigger.next();
    }
  }

  private async init(): Promise<void> {

    this._ngxUiLoaderService.start();
    await this._loadTabData(0);
    //this.VasDetails = await this._auditService.GetVASCustomerDetails(this.merchantNumber);
    this.dtTrigger.next();

    this.countryCodes = (await this._terminalConfigService.GetCountryCodes()).map((x) => {
      return { id: x.currencyCode.toString(), text: x.country + ' (' + x.currencyCode + ')' }
    });

    this.baseCurrencies = (await this._terminalConfigService.GetCountryCodes()).map((x) => {
      return { id: x.currencyCode.toString(), text: x.country + ' (' + x.currencyCode + ')' }
    });

    this.terminalTypes = (await this._terminalConfigService.GetTerminalTypes()).map((x) => {
      return { id: x.id.toString(), text: x.name + ' (' + x.name + ')' }
    });


    this.timezonecodes = (await this._terminalConfigService.GetTimeZoneCodes()).map((x) => {
      return { id: x.timeZoneId.toString(), text: x.timeZoneId.toString() }
    });

    this.bINProfiles = (await this._terminalConfigService.GetBinProfiles()).map((x) => {
      return { id: x.profile.toString(), text: x.profile.toString() }
    });

    this.disableMediaManagement = (await this._terminalConfigService.GetCountryCodes()).map((x) => {
      return { id: x.currencyCode.toString(), text: x.country + ' (' + x.currencyCode + ')' }
    });

    this.supportTeams = (await this._terminalConfigService.GetSupportTeams()).map((x) => {
      return { id: x.id.toString(), text: x.name }
    });

    this.suppliesTeams = (await this._terminalConfigService.GetSupportTeams()).map((x) => {
      return { id: x.id.toString(), text: x.name }
    });

    this.mediaTeams = (await this._terminalConfigService.GetSupportTeams()).map((x) => {
      return { id: x.id.toString(), text: x.name }
    });

    this.securityTeams = (await this._terminalConfigService.GetSupportTeams()).map((x) => {
      return { id: x.id.toString(), text: x.name }
    });

    this.driverIds = (await this._terminalConfigService.GetTermDriverID()).map((x) => {

      return { id: x.id.toString(), text: x.description + ' (' + x.termTypeId + ')' }
    });

    setTimeout(() => {
      this.terminalConfigForm.markAsPristine();
    });

    this._ngxUiLoaderService.stop();
  }

  private async _loadTabData(index: number): Promise<void> {

    switch (index) {

      case 1:
        if (this.creatingNew != true) {
          const result = await this._terminalConfigService.Get(this.id);
          this.terminalConfigForm.patchValue(result);
        }
        break;

      case 2:
        this.terminalGroups = (await this._customTagService.GetTerminalGroups()).map((x) => {
          return { id: x.term_group_name.toString(), text: x.term_group_name }
        });
        if (this.creatingNew == false) {
          this.TerminalGroupsByParticipant = await this._customTagService.GetGroupsByParticipantIdTerminalConfigId(this.participantId, Number(this.id));
        }
        this.filterTerminalGroups();
        break;

      default:
        if (this.creatingNew != true) {
          const result2 = await this._terminalConfigService.Get(this.id);
          this.terminalConfigForm.patchValue(result2);
        }
    }
  }

  onKeyUp(event: any): void {
    this.numberOfCharacters1 = event.target.value.length;

    if (this.numberOfCharacters1 > this.maxNumberOfCharacters) {
      event.target.value = event.target.value.slice(0, this.maxNumberOfCharacters);
      this.numberOfCharacters1 = this.maxNumberOfCharacters;
    }
  }

  public async updateForm(): Promise<void> {
    setTimeout(() => {
      debugger;
      var configType = this.terminalConfigForm.controls.configType.value;
      this.displayTAContent = +this.terminalConfigForm.controls.configType.value === this.postTerm;

      if (configType === this.postTerm) {
        this.terminalConfigForm.patchValue({ type: 22 });
      }
      else if (configType == this.termApp) {
        this.terminalConfigForm.patchValue({ type: 350 });
      }
      else if (configType == this.eSocket) {
        this.terminalConfigForm.patchValue({ type: 103 });
        this.eSocketConfig = true;
      }     

    }, 2000);

  }

  public async saveTerminalConfig(): Promise<void> {
    
    this.submitted = true;
    if (this.terminalConfigForm.valid) {
      const configViewModel: TerminalConfigViewModel = this.terminalConfigForm.value;

      if (!this.creatingNew) {
        //update Terminal Config

        configViewModel.participantId = +configViewModel.participantId;
        configViewModel.configType = +configViewModel.configType;
        configViewModel.active = +configViewModel.active;
        configViewModel.disableHotcards = +configViewModel.disableHotcards;
        configViewModel.daysToKeepStats = +configViewModel.daysToKeepStats;

        configViewModel.gmtTimeZoneOffset = +configViewModel.gmtTimeZoneOffset;
        configViewModel.hotFileId = +configViewModel.hotFileId;
        configViewModel.mediaTeam = +configViewModel.mediaTeam;
        configViewModel.mode = +configViewModel.mode;
        configViewModel.securityTeam = + configViewModel.securityTeam;
        configViewModel.suppliesTeam = + configViewModel.suppliesTeam;
        configViewModel.supportTeam = + configViewModel.supportTeam;
        configViewModel.heartBeat = +configViewModel.heartBeat;
        configViewModel.enableEjUpload = +configViewModel.enableEjUpload;
        configViewModel.echoInterval = +configViewModel.echoInterval;
        configViewModel.dukptManagement = +configViewModel.dukptManagement;
        configViewModel.type = +configViewModel.type;
        configViewModel.usePosDataCodeConfig = + configViewModel.usePosDataCodeConfig;
        configViewModel.driverId = +configViewModel.driverId;
        configViewModel.supportTeam = +configViewModel.supportTeam;
        configViewModel.functionVector = Boolean(JSON.parse("" + configViewModel.functionVector));


        this.createResult = await this._terminalConfigService.Update(configViewModel);

        if (this.createResult.success === true) {
          this._toastService.success(this.createResult.message, "Success");
          this.raiseDanger = false;
        } else {
          this._toastService.error(this.createResult.message, "Error");
          this.raiseDanger = true;
          this.danger = this.createResult.message;
        }
      }
      else {
        //New Terminal Config
        configViewModel.id = 1;
        configViewModel.participantId = +configViewModel.participantId;
        configViewModel.configType = +configViewModel.configType;
        configViewModel.active = +configViewModel.active;
        configViewModel.dropIdleConnections = +configViewModel.dropIdleConnections;
        configViewModel.daysToKeepStats = +configViewModel.daysToKeepStats;

        configViewModel.gmtTimeZoneOffset = +configViewModel.gmtTimeZoneOffset;
        configViewModel.hotFileId = +configViewModel.hotFileId;
        configViewModel.mediaTeam = +configViewModel.mediaTeam;
        configViewModel.mode = +configViewModel.mode;
        configViewModel.securityTeam = +configViewModel.securityTeam;
        configViewModel.suppliesTeam = +configViewModel.suppliesTeam;
        configViewModel.supportTeam = +configViewModel.supportTeam;
        configViewModel.worstEventSeverity = +configViewModel.worstEventSeverity;
        configViewModel.heartBeat = +configViewModel.heartBeat;
        configViewModel.heartbeatDelay = +configViewModel.heartbeatDelay;
        configViewModel.enableEjUpload = +configViewModel.enableEjUpload;
        configViewModel.sampleRate = +configViewModel.sampleRate;
        configViewModel.echoInterval = +configViewModel.echoInterval;
        configViewModel.dukptManagement = +configViewModel.dukptManagement;
        configViewModel.disableMediaManagement = +configViewModel.disableMediaManagement;
        configViewModel.type = +configViewModel.type;
        configViewModel.usePosDataCodeConfig = +configViewModel.usePosDataCodeConfig;
        configViewModel.driverId = +configViewModel.driverId;

        this.canAdd = this._userDataStore.hasRequiredPermissions([PermissionEnum.AddTerminalConfiguration], []);
        if (!this.canAdd) {
          this._toastService.error("You do not have the required permissions to add a terminal config record.", "error");
        }
        else {
          this.createResult = await this._terminalConfigService.Add(configViewModel);

          if (this.createResult.success === true) {

            this._toastService.success(this.createResult.message, "Success");
            await this._router.navigate(['management', 'terminal-config']);
            this.raiseDanger = false;
          } else {
            this._toastService.error(this.createResult.message, "Error");
            this.raiseDanger = true;
            this.danger = this.createResult.message;
          }
        }
      }
    }

    this.terminalConfigForm.markAsPristine();
  }

  public async delete(): Promise<void> {
    if (!this.canEdit) {
      this._toastService.error("You do not have the required permissions to perform this action.", "Error");
    } else {
      this.createResult = await this._terminalConfigService.DeleteTerminalConfig(this.terminalConfigForm.controls.id.value);
      if (this.createResult.success === true) {
        await this._router.navigate(['management', 'terminal-config']);
        this._toastService.success(this.createResult.message, "Success");
      } else {
        this._toastService.error(this.createResult.message, "Error");
      }
    }
  }

  public async determineDeleteDialog() {
    const terminalDetails = await this._terminalConfigService.GetAllTerminalDetails(this.terminalConfigForm.controls.id.value);
    if (!!terminalDetails && terminalDetails.length === 0) {
      await this.openDeleteConfirmationDialog();
    } else {
      await this.openUsedDeleteFailureConfirmationDialog(terminalDetails.map(td => td.terminalId));
    }
  }

  public async linkTags(groupName: string) {

    const modalRef = this._modalService.open(TerminalGroupCustomParameterComponent, {
      windowClass: 'modal-fade-in',
      centered: false,
      size: 'xl',
      backdrop: 'static'
    });

    var obj = {
      terminalConfigId: Number(this.id),
      groupName: groupName,
      participantId: this.participantId
    }

    modalRef.componentInstance.terminalGroupCustomParameter = obj;

    await modalRef.result;
  }


  public async openDeleteConfirmationDialog(): Promise<void> {
    const dialogRef = this._modalService.open(ConfirmationDialogComponent, {
      windowClass: 'modal-fade-in',
      centered: false,
      size: 'xl',
      backdrop: 'static'
    });
    dialogRef.componentInstance.showCancel = true;
    dialogRef.componentInstance.acceptButtonText = "Yes";
    dialogRef.componentInstance.cancelButtonText = "No"
    dialogRef.componentInstance.title = "Terminal Config Removal"
    dialogRef.componentInstance.message = "Are you sure you want to delete the selected terminal config?"

    const result = await dialogRef.result;
    if (result) {
      await this.delete();
    }
  }

  public async openUsedDeleteFailureConfirmationDialog(terminals: string[]) {
    const dialogRef = this._modalService.open(ConfirmationDialogComponent, {
      windowClass: 'modal-fade-in',
      centered: false,
      size: 'xl',
      backdrop: 'static'
    });
    dialogRef.componentInstance.acceptButtonText = "OK"
    dialogRef.componentInstance.title = "Terminal Config Cannot Be Removed"
    dialogRef.componentInstance.message = "This Terminal Config is currently in use and cannot be deleted.<br/><br/><b>Terminals using config:</b>"
    dialogRef.componentInstance.listMessage = terminals;
  }

  public onDateSelect(ngbDate: NgbDate, dateProperty: Date): void {
    dateProperty = new Date(ngbDate.year, ngbDate.month - 1, ngbDate.day);
  }

  public ngOnDestroy(): void {
    this._destroyed$.next();
    this._destroyed$.complete();
  }

}
